@let hasLabelReadPermission = can(RoleAction.Read, RolePermissionSubject.Label);

<nz-collapse [nzBordered]="false" nzGhost>
  <nz-collapse-panel
    #usersPanel
    class="collapse-panel"
    [nzHeader]="usersSectionHeader"
    [nzActive]="true"
    [nzShowArrow]="false"
    [nzExtra]="usersCollapseIcon"
  >
    <div>
      <span class="mb-0 filter-label">
        {{ 'general.username' | translate }}
      </span>
      <wilson-users-list-filter
        [placeholder]="'general.username' | translate"
        (modelChange)="usersChanged($event)"
        class="mb-2"
      ></wilson-users-list-filter>
    </div>
    <div>
      <span class="mb-0 filter-label">
        {{ 'general.role' | translate }}
      </span>
      <wilson-user-role-filter
        [placeholder]="'general.role' | translate"
        class="mb-2"
        (modelChange)="userRolesChanged($event)"
      ></wilson-user-role-filter>
    </div>
    <div>
      <span class="mb-0 filter-label">
        {{ 'service.shift_orgunit' | translate }}
      </span>
      <wilson-organizational-unit-filter
        class="mb-2"
        (modelChange)="orgUnitsChanged($event)"
      ></wilson-organizational-unit-filter>
      @if (timelineFilterHelperService.isCopyOrgUnitFromShiftVisibleSignal()) {
        <div class="copy-text">
          <span class="cursor-pointer" (click)="copyOrgUnitFromShift()">
            {{ 'timeline.filters.copy_from_shift_filter' | translate }}
            <fa-icon [icon]="faPlusSquare" class="ms-1"></fa-icon>
          </span>
        </div>
      }
    </div>
    @if ('portal-labels' | featureFlagPure | async) {
      <ng-container>
        <span class="mb-0 filter-label">
          {{
            'page.payroll_settings.custom_payroll_category.type_of_rule.label'
              | translate
          }}
        </span>
        @if (hasLabelReadPermission) {
          <wilson-labels-filter
            [placeholder]="
              'page.payroll_settings.custom_payroll_category.type_of_rule.label'
                | translate
            "
            (modelChange)="labelsChanged($event)"
            class="mb-2"
          ></wilson-labels-filter>
        } @else {
          <nz-select
            nzMode="multiple"
            nzAllowClear
            [nzShowArrow]="true"
            [nzPlaceHolder]="
              'page.payroll_settings.custom_payroll_category.type_of_rule.label'
                | translate
            "
            class="mb-2"
            [nzDisabled]="true"
            nz-tooltip
            [nzTooltipTitle]="'general.forbidden_action' | translate"
            data-test-id="wilson-timeline-filter:labels-select"
          ></nz-select>
        }
        @if (timelineFilterHelperService.isCopyLabelFromShiftVisibleSignal()) {
          <div class="copy-text">
            <span class="cursor-pointer" (click)="copyLabelFromShift()">
              {{ 'timeline.filters.copy_from_shift_filter' | translate }}
              <fa-icon [icon]="faPlusSquare" class="ms-1"></fa-icon>
            </span>
          </div>
        }
      </ng-container>
    }
    <div>
      <span class="mb-0 filter-label">
        {{ 'professions.label' | translate }}
      </span>
      <wilson-profession-filter
        (modelChange)="professionChanged($event)"
        [labelVisible]="false"
        [placeholder]="'professions.label' | translate"
        class="mb-2"
      ></wilson-profession-filter>
      @if (
        timelineFilterHelperService.isCopyProfessionFromShiftVisibleSignal()
      ) {
        <div class="copy-text">
          <span class="cursor-pointer" (click)="copyProfessionFromShift()">
            {{ 'timeline.filters.copy_from_shift_filter' | translate }}
            <fa-icon [icon]="faPlusSquare" class="ms-1"></fa-icon>
          </span>
        </div>
      }
    </div>
    @if ('portal-timeline-home-location-filter' | featureFlagPure | async) {
      <div>
        <span class="mb-0 filter-label">
          {{ 'general.home_location' | translate }}
        </span>
        <wilson-activity-location-filter
          class="mb-2"
          [filterKey]="'homeLocation'"
          [showLabel]="false"
          [label]="'general.home_location' | translate"
          (modelChange)="homeLocationChanged($event)"
        ></wilson-activity-location-filter>
      </div>
    }
  </nz-collapse-panel>
  <ng-template #usersSectionHeader>
    <span class="fw-normal">
      {{ 'general.users' | translate }}
    </span>
  </ng-template>
  <ng-template #usersCollapseIcon>
    <fa-icon
      [icon]="usersPanel.nzActive ? faChevronUp : faChevronDown"
    ></fa-icon>
  </ng-template>
</nz-collapse>
